import { createContext } from "react";
import { CustomThemeType } from "../ThemeProvider";

export type ThemeProviderContextProps = {
  theme?: CustomThemeType;
  mode?: "light" | "dark";
};

export const ThemeProviderContext = createContext<ThemeProviderContextProps>(
  {},
);
